import http from "../http";

const IpadUserService = {

    getUsers: async () => {
        const users = await http.instance.get("/IpadUsers");
        return users.data;
    },

    getUser: async (id) => {
        const users = await http.instance.get("/IpadUsers/Id",{params:{id:id}});
        return users.data;
    },

    updateUsers: async (form) => {
        const users = await http.instance.post("/IpadUsers/Edit",form);
        return users.data
    },

    addUsers: async (form) => {
        const users = await http.instance.post("/IpadUsers/Add",form);
        return users.data;
    },

};

export default IpadUserService;
